import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { EstimateService } from '../../../services/estimate.service';
import { CatalogService } from '../../../services/catalog.service';
import { AddCodesFileModel, EstimateModel, ItemByCategoryModel } from '../../../models/estimate.model';
import Swal from 'sweetalert2';
import { CodesFileModel } from '../../../models/codes-file.model';    
import { SetupService } from '../../../services/setup.service';
import { ClientService } from '../../../services/client.service';
import { ProcedureService } from '../../../services/procedure.service'; 
import { CategoryModel } from '../../../models/category.model';
import { EstimateDefModel } from '../../../models/estimate.model';
import { DeleteATranModel } from "../../../models/delete-a-tran.model";
import { TranRecordModel } from '../../../models/tran-record.model';
import { INVENT } from '../../../../environments/environment';
import { CheckPetSexSpecieModel } from '../../../models/check-pet-sex-specie.model';
import { encode_base64, encode_utf8 } from '../../../../environments/environment';
import { SharedService } from '../../../services/shared.service';
import { EmailService } from '../../../services/email.service';
import { NgForm } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'ngx-work-estimates',
  templateUrl: './estimates.component.html',
})
export class EstimatesComponent implements OnInit {

  private _pet_no: number;
  tab_no: number = 1;
  suggestedWordsArray: CodesFileModel[] = [];
  signerName: string = '';
  signerNotes: string = '';
  isApproved: boolean = false;
  hasSigned: boolean = false;

  EstimateName: string = '';
  EstimateRemarks: string = '';
  saveAsType: string = '';

  private signaturePad?: any;
  now: Date = new Date();
  public signaturePadOptions: Object = {
    minWidth: 2
  };

  @ViewChild('signaturePadClient') signaturePadClient!: SignaturePad;
  @ViewChild('signaturePadAttending') signaturePadAttending!: SignaturePad;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getEstimatesByPetId(this.petService.current_pet_no).then(() => { });
    this.getEstGroupsList();
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    public procedureService: ProcedureService,
    public setupService: SetupService,
    public clientService: ClientService,
    public sharedService: SharedService,
    public emailService: EmailService,
    public estimateService: EstimateService,
    private route: ActivatedRoute
  ) {
    this.catalogService.getCategories().then(() => {});
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
          this.petService.getEstimatesByPetId(this.petService.current_pet_no).then(() => {
            console.log("petService.pet_generic_estimates", this.petService.pet_generic_estimates);
            console.log("petService.pet_estimates", this.petService.pet_estimates);
           }); 
        }
      }); 
  }

  //#region OLD CODE
  // Approval modal handlers
  openApprovalModal() {
    setTimeout(() => this.initSignaturePad(), 50);
    $('#modalEstimateApproval').modal('show');
  }

  private initSignaturePad() {
    // Use angular2-signaturepad pads and resize to container
    const pads: SignaturePad[] = [this.signaturePadClient, this.signaturePadAttending].filter(Boolean) as SignaturePad[];
    pads.forEach(pad => {
      const canvas = pad['canvas'] as HTMLCanvasElement;
      if (!canvas) { return; }
      const rect = canvas.parentElement?.getBoundingClientRect();
      if (rect) {
        canvas.width = rect.width - 2; // account for borders
        canvas.height = 160;
      }
      pad.clear();
    });
  }

  clearSignature() {
    this.signaturePadClient?.clear();
    this.signaturePadAttending?.clear();
    this.hasSigned = false;
  }

  submitApprovals() {
    // Collect payload
    const payload = {
      client_no: this.clientService.client.client_no,
      pet_no: this.petService.pet.pet_no,
      estimate_sequence: this.petService.pet_estimate.estimate_sequence,
      total: this.getTotalCost(),
      signer_name: this.signerName,
      notes: this.signerNotes,
      approved: this.isApproved,
      client_signature_image_base64: this.signaturePadClient?.toDataURL() || '',
      attending_signature_image_base64: this.signaturePadAttending?.toDataURL() || ''
    };

    // TODO: send to backend when endpoint is ready
    console.log('Estimate approval payload', payload);

    $('#modalEstimateApproval').modal('hide');
    this.signerName = '';
    this.signerNotes = '';
    this.isApproved = false;
    this.hasSigned = false;
  }

  getTotalQuantity(): number {
    if (!this.petService.pet_estimate.estimate_def) { return 0; }
    return this.petService.pet_estimate.estimate_def
      .filter(item => item.link_count !== 0)
      .reduce((sum, item) => sum + (Number(item.link_count) || 0), 0);
  }

  // add() {
    
  //   this.petService.pet_estimate.estimate_sequence = 0;
  //   this.petService.pet_estimate.pet_no = (this.tab_no == 1)? this._pet_no: 0;
  //   this.petService.pet_estimate.estimate_name = '';
  //   this.petService.pet_estimate.estimate_def = [];
  //   this.petService.pet_estimate.date_added = '';
  //   this.petService.pet_estimate._total_charge=0;
  //   this.petService.pet_estimate.items_by_category.forEach(element => {
  //     element.procs = []
  //   });

    // if (this.catalogService.categories && this.catalogService.categories.length > 0) {
    //   this.catalogService.categories.forEach(element => {
    //     this.petService.pet_estimate.items_by_category.push(new ItemByCategoryModel([], element.category_name, element.category_no, element.category_code, 0, 0));
    //   });
    // }



    //$('#modalNewPetEstimate').modal('toggle')
  //   $('#modalCreateEstimate').modal('toggle')
  // }
 
  delete(item: EstimateModel) {
    Swal.fire({
      title: 'Delete this estimate?',
      // icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes'
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Loading...',
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
          },
        })
        this.petService.deletePetEstimate(item)
          .then(() => {
            this.petService.getEstimatesByPetId(this.petService.current_pet_no)
              .then(() => {
                Swal.close();
              });
          });
      }
    });
  }
  

  clearItems() { 
    this.petService.pet_estimate.estimate_sequence = 0;
    this.petService.pet_estimate.estimate_name = '';
    this.petService.pet_estimate.estimate_note = '';
    this.petService.pet_estimate.estimate_def = []; 
    this.totalEstimate = 0;
    this.petService.pet_estimate._total_charge = 0;
  }
  //#endregion

  //#region Tabbed Estimate

  setActiveTab(tabNumber: number): void {
    this.tab_no = tabNumber;
  }
 
  //#endregion

  estimatesListBtn(){
    $('#modalEstimates').modal('toggle')
  }
 
  //#region Table Display
  buscador_activo: boolean = false;
  new_item_by_category: AddCodesFileModel = new AddCodesFileModel(0, '', '', '', '', 0, false);
  txtCount_Tag: any;
  new_item_by_category_status: string = '';
  totalEstimate: number = 0

  getStatusOption() { 
      return [
          { status: 'R', desc: 'R - Request' },  
          { status: 'S', desc: 'S - Suggested' },
          { status: 'T', desc: 'T - Treatment' }, 
      ]; 
  }



  openEstimate(item: EstimateModel) {
    this.petService.pet_estimate = item;

    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
 
    this.petService.getEstimatesDetail(item.estimate_sequence, this.petService.userData.clinic_no).then(() => { 
      Swal.close();
      $('#modalEstimates').modal('hide');
    }) 
  }

  search(event: any) { 
    setTimeout(() => {

      this.petService.pet_recall.recall_proc1 = event.target.value;

      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.suggestedWordsArray = [];
        this.buscador_activo = false;
      }

      if (this.petService.pet_recall.recall_proc1.length > 1) {
        this.suggestedWordsArray = [];
        this.suggestedWordsArray.push(...this.catalogService.filterArray<CodesFileModel>(this.catalogService.codes_file, this.petService.pet_recall.recall_proc1.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), "code_name"));
        this.suggestedWordsArray.push(...this.catalogService.filterArray<CodesFileModel>(this.catalogService.codes_aliases, this.petService.pet_recall.recall_proc1.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, ""), "code_name"));
        this.buscador_activo = this.suggestedWordsArray.length > 0;

      } else {
        this.suggestedWordsArray = [];
        this.buscador_activo = this.suggestedWordsArray.length > 0;
      }
    }, 100); 
  }
 

  async define(code_name: string, index: number) {
      let intIdx = -1;

      Swal.fire({
        title: 'Loading...',
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let trans: TranRecordModel[] = [];
      trans.length = 2;

      const curUser = this.procedureService.getCurrentUserInfo();
      const EstTrans = await this.procedureService.requestProc(trans, intIdx, 0, code_name, 'R', curUser.initial, curUser.employee_no, this.petService.current_client_no, this.petService.current_pet_no, 0, null, 0, null, null);
      if (EstTrans.RequestProc >= 0) {
        console.log("EstTrans:", EstTrans);
        let EstTrans_trans: TranRecordModel[] = EstTrans.Trans;
        let txtCount = (this.new_item_by_category.quantity != '') ? Number(this.new_item_by_category.quantity) : 0;
        const intTotalIdx = EstTrans.Trans.length;

        for (let i = 0; i < intTotalIdx; i++) {
          if (EstTrans.Trans[0].Status == "C") {
            intIdx = -1;
            await this.procedureService.requestProc(EstTrans_trans, intIdx, EstTrans_trans.length, EstTrans_trans[i].LinkName, 'R', curUser.initial, curUser.employee_no, this.petService.current_client_no, this.petService.current_pet_no, 0, null, null, null, null);
          }
        }

        if (this.new_item_by_category.code_name == "MISC") {
          EstTrans_trans[0].Unit = txtCount;
        }

        for (let i = 0; i < intTotalIdx - 1; i++) {
          const doneproc = await this.procedureService.doneProc(EstTrans_trans, i, intTotalIdx, curUser.initial, curUser.employee_no, true, '', 1);
          if (doneproc) {
            console.log("doneproc:", doneproc);
            if (EstTrans_trans[i].SupSeq === 0) {
              this.new_item_by_category.price = String(Number(EstTrans_trans[i].Cost) + Number(this.new_item_by_category.price));
            }
          }
        }

        if (EstTrans_trans.length == 1) {
          if (txtCount != 0) {
            if (this.new_item_by_category.code_name != 'MISC') {
              EstTrans_trans[0].Unit = txtCount;
            } else {
              EstTrans_trans[0].Cost = EstTrans_trans[0].UnitCost;
            }
            EstTrans_trans[0].Cost = (this.txtCount_Tag == "P") ? (EstTrans_trans[0].Cost * txtCount) : ((EstTrans_trans[0].Cost - EstTrans_trans[0].UnitCost) + (EstTrans_trans[0].UnitCost * txtCount));
            this.new_item_by_category.price = String(EstTrans_trans[0].Cost);
            this.new_item_by_category.defined = true;
            this.petService.UpdateTranUnitCost(txtCount, EstTrans_trans[0].Cost, EstTrans_trans[0].Seq);
          }
        }

        //if (this.addprocbtn_actv) {
          this.add();
        // } else {
          //this.update(index, true);
        // }

        await this.procedureService.deleteATran(new DeleteATranModel(EstTrans_trans, 0, EstTrans_trans.length, true, '', this.petService.userData.clinic_no, 0, false));
      }
      else if(EstTrans.RequestProc == -1 && index != null){
        this.update(index, false);
      }
      Swal.close();
  }

  add() { 
    console.log("add", this.new_item_by_category);
    let new_estdef = new EstimateDefModel(
      this.petService.pet_estimate.estimate_sequence,
      0,
      this.new_item_by_category.code_no,
      this.new_item_by_category.code_type,
      Number(this.new_item_by_category.quantity),
      Number(this.new_item_by_category.price),
      this.new_item_by_category.defined,
      this.new_item_by_category_status,
      this.new_item_by_category.code_name,
      this.new_item_by_category.procedure_desc,
      this.new_item_by_category.code_category,
      this.new_item_by_category.type 
    )  
    this.petService.pet_estimate.estimate_def.push(new_estdef)
 
    console.log("this.petService.pet_estimate.estimate_def", this.petService.pet_estimate.estimate_def);
    this.new_item_by_category = new AddCodesFileModel(0, '', '', '', '', 0, false);
    this.new_item_by_category_status = '';

    //get total
    this.totalEstimate = this.petService.pet_estimate.estimate_def.reduce((sum, item) => sum + Number(item.link_cost), 0);
    this.petService.pet_estimate._total_charge = this.totalEstimate;

  }

  update(index: number, withtrans: boolean) { 
    console.log("update", index, withtrans);
    if(withtrans){
        this.petService.pet_estimate.estimate_def[index].link_cost = Number(this.new_item_by_category.price) 
    }
    else{
        this.petService.pet_estimate.estimate_def[index] = new EstimateDefModel(0,0,0,0,0,0,false,'','','','','');
    }
    
  }

  modalSaveAsNew(type: string) {
    this.saveAsType = type;
    $('#modalSaveAsNew').modal('show'); 

    this.EstimateName = '';
    this.EstimateRemarks = '';  
  }

  saveasPetEstimate(printEstimate: boolean = false) {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
 
    this.petService.pet_estimate.estimate_name = this.EstimateName
    this.petService.pet_estimate.estimate_note = this.EstimateRemarks
    this.petService.pet_estimate.pet_no = this.pet_no

    this.petService.setupPetEstimate()
      .then(() => {
        this.petService.getEstimatesByPetId(this.petService.current_pet_no)
          .then(() => {
            Swal.close(); 
            $('#modalSaveAsNew').modal('hide');
            Swal.fire({title: 'Information stored correctly', icon: 'success'}) 
          });
      });
  }

  saveasGenericEstimate(){
    this.petService.pet_estimate_generic = this.petService.pet_estimate; 
    this.petService.pet_estimate_generic.estimate_name = this.EstimateName
    this.petService.pet_estimate_generic.estimate_note = this.EstimateRemarks
    this.petService.pet_estimate.pet_no = 0
    this.petService.setupPetEstimateGeneric()
      .then(() => {
        this.petService.getEstimatesByPetId(this.petService.current_pet_no)
          .then(() => { 
            Swal.close(); 
            $('#modalSaveAsNew').modal('hide');
            Swal.fire({title: 'Information stored correctly', icon: 'success'}) 
          });
      });
  } 
  

  //#endregion

  getTotalCost(): number {
    if (!this.petService.pet_estimate.estimate_def || this.petService.pet_estimate.estimate_def.length === 0) {
      return 0;
    }
    
    return this.petService.pet_estimate.estimate_def
      .filter(item => item.link_count !== 0)
      .reduce((total, item) => total + (item.link_cost || 0), 0);
  }

  async redefineItems() { 
    for (let index = 0; index < this.petService.pet_estimate.estimate_def.length; index++) {
      const element = this.petService.pet_estimate.estimate_def[index];
      await this.define(element.code_name, index);  
    }

    for (let index = 0; index < this.petService.pet_estimate.estimate_def.length; index++) {
      if (this.petService.pet_estimate.estimate_def[index].link_count == 0) {
        this.petService.pet_estimate.estimate_def.splice(index, 1);
      }
    }

  }

  //#region FOR REPORT

  private escapeXml(value: string): string {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  
  private buildXmlFromPoData(): string {
    const rows = (this.petService.pet_estimate.estimate_def || [])
      .filter(r => Object.values(r).some(v => (v ?? '').toString().trim() !== ''))
      .map(r =>
        //<Row proc="" desc="" cat="" qty="" price="0"  />
        `<Row proc="${this.escapeXml(r.code_name)}" desc="${this.escapeXml(r.procedure_desc)}" cat="${this.escapeXml(r.code_category)}" qty="${this.escapeXml(r.link_count.toString())}" price="${this.escapeXml(r.link_cost.toString())}" />`
      )
      .join('');
    return `<Rows>${rows}</Rows>`;
  }

  getClientSignaturePromise(): Promise<number> {
    return this.clientService
      .setupSignatureSolo(0, this.clientService.releasedEstimate.client_no, 2, this.signaturePadClient.toDataURL(), null, '', '')
      .then((client_signature: any) => Number(client_signature));
  }

  getAttendeeSignaturePromise(): Promise<number> {
    return this.clientService
      .setupSignatureSolo(0, this.clientService.userData.id, 2, this.signaturePadAttending.toDataURL(), null, '', '')
      .then((attendee_signature: any) => Number(attendee_signature));
  }
  
  async print() {
      const xml = this.buildXmlFromPoData(); 
      const [client_sig, attendee_sig] = await Promise.all([
        this.getClientSignaturePromise(),
        this.getAttendeeSignaturePromise()
      ]);
  

      let $string = `admin` + "U*63r" + 'FPC_ReleasedEstimate' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `FPC_ReleasedEstimate ${new Date().getTime()}` + "T1*73";
      let $result = encode_utf8($string);
      $result = encode_base64($result);
      const xmlB64 = encode_base64(encode_utf8(xml));
      let $resultSafe = encodeURIComponent($result);
      let strfilter = `&clinic_no=${this.petService.userData.clinic_no}&client_no=${this.petService.pet.client_no}&XMLData=${encodeURIComponent(xmlB64)}&client_sig=${client_sig}&attendee_sig=${attendee_sig}&pet_no=${this.petService.pet.pet_no}`; 
    
      let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$resultSafe}${strfilter}`; 

      window.open(url, '_self', 'visible=none');
  }

  async emailToClient(){  
      const xml = this.buildXmlFromPoData(); 
      const [client_sig, attendee_sig] = await Promise.all([
        this.getClientSignaturePromise(),
        this.getAttendeeSignaturePromise()
      ]);

      let additional_params = {   
        clinic_no: this.petService.userData.clinic_no,
        client_no: this.clientService.client.client_no,
        pet_no: this.petService.pet.pet_no,
        XMLData: encode_base64(encode_utf8(xml)),
        client_sig: client_sig,
        attendee_sig: attendee_sig,
      }
  
      const params = { 
        report_name: 'rptFPC_ReleasedEstimate', 
        download: 'true',
        inline: 'true', 
        ...additional_params
      }; 

      //&startdate=${this.startDate}&enddate=${this.endDate}
      // let additional_params = {   
      //    startdate: '2025-09-01',
      //    enddate: '2025-09-30'
      // }

      // const params = { 
      //   report_name: 'FPC_ApptDateRangeRpt', 
      //   download: 'true',
      //   inline: 'true', 
      //   ...additional_params
      // }; 
   
      this.sharedService.GetReportData(params).then((data) => { 
        this.emailService.openEmailModal(
          {'from': '', 
          'to': [this.clientService.client.email_address], 
          'subject': 'Estimate Report for ' + this.petService.pet.pet_name, 
          'body': 'Attached is an updated Supplier Scorecard. Please review the findings and respond if required.',
          'attachmentPath': data
        }); 
      }); 
  }


  //#endregion


  //#region Modal Add Procedure

  openModalAddProcedure() {
    this.procedureService.estimation = true;
    $('#modalAddProcedure').modal('show');
  }

  //#endregion 






  //#region NEW ESTIMATE (with procedure)
  txtchar: any;
  buscador_activo_status: boolean = false;
  filterText: string = '';

  select(item: CodesFileModel) {
      this.filterText = item.code_name;
      this.petService.pet_proc.code_no = item.code_no;
      this.petService.pet_proc.code_type = item.code_type;
      this.petService.pet_proc.code_name = item.code_name;
      this.petService.pet_proc.procedure_desc = item.procedure_desc;
      this.suggestedWordsArray = [];
      this.buscador_activo = this.suggestedWordsArray.length > 0;
      this.buscador_activo_status = true;
      //  debugger;
  }

  onStatInput() {
      this.txtchar = this.txtchar.toUpperCase();
      console.log('onStatInput', this.txtchar);
      this.AddProcedure()
  }

  onStatusSelected(target, formAddProcedures: NgForm) {
      //console.log(target, formAddProcedures);
      this.buscador_activo_status = false;
      if (formAddProcedures.valid) {
          this.procedureService.estimation = true; 
          formAddProcedures.ngSubmit.emit();
      }
  } 

  async AddProcedure() {
    let code: CodesFileModel;

    switch (this.txtchar) {
        case '*': //AddVaccine
            code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
            console.log(this.filterText, code);

            if (this.catalogService.clinic_code.some(t => t.pet_info_proc_no === code.code_no && t.pet_info_proc_type === code.code_type)) {

                $('#modalAddProc').modal('hide')
                return;
            }

            let brief_history_category = code.brief_history_category.trim();
            if (brief_history_category === '') {
                // Brief history category not found for this code.
                Swal.fire({
                    title: 'Brief history category not found for this code.',
                    didOpen: () => {
                    },
                })
                return;
            }

            Swal.fire({
                title: 'Loading...',
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            this.procedureService.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, 1, '', 0);
            this.procedureService.checkPetSexSpecie()
                .then(() => {
                    Swal.close();

                    if (this.procedureService.check_pss.check === 1) {
                        $('#modalAddProc').modal('hide')
                        $('#modalAddVaccine').modal('show')
                    } else {
                        Swal.fire({
                            title: this.procedureService.check_pss.message,
                            didOpen: () => {
                            },
                        })
                        return;
                    }

                });

            break;
        case '$': //PriceLookup
            code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
            if (code.code_type !== INVENT) {
                //Price lookup feature can only be used on inventory codes.
                Swal.fire({
                    title: 'Price lookup feature can only be used on inventory codes.',
                    didOpen: () => {
                    },
                })
                return;
            }

            let LTrans: TranRecordModel[] = Array(2).fill(new TranRecordModel());
            let intTotal = 1
            let intIndex = -1

            let result = await this.requestProc(LTrans, intIndex, intTotal, this.filterText, 'R', 'ref', 1, this.clientService.current_client_no, this.petService.current_pet_no, 0);
            if (result.RequestProc >= 0) {
                if (LTrans[intIndex].Attending <= 0) {
                    //UpdateDocs
                }

                let DoneProc = true; //****
                if (DoneProc) {
                    Swal.fire({
                        title: `Price Lookup`,
                        text: `Price of ${LTrans[intIndex].LinkName} is ${LTrans[intIndex].Cost}`,
                        didOpen: () => {
                        },
                    }).then(() => {
                        //DeleteATran
                    });
                } else {
                    Swal.fire({
                        text: `Could not calculate price for ${this.filterText}.`,
                        didOpen: () => {
                        },
                    })
                }
            } else {
                Swal.fire({
                    text: `Could not request ${this.filterText} for a price look up.`,
                    didOpen: () => {
                    },
                })
            }
            break;
        default:
            this.proc();
            break;
    } 


  }

  async requestProc(Trans: TranRecordModel[], intIndex: number, intTotalIdx: number, strCodeName: string, strStatus: string, strReqEmp: string, intEmpNo: number,
      lngClientNo: number, lngPetNo: number, lngSupSeq: number, sglPrice?: number, sglLUnit?: number, strLFix?: string, strLChk?: string) {
      return await this.procedureService.requestProc(Trans, intIndex, intTotalIdx, strCodeName, strStatus, strReqEmp, intEmpNo,
          lngClientNo, lngPetNo, lngSupSeq, sglPrice, sglLUnit, strLFix, strLChk);
  }

  async proc() {
    if (this.petService.pet_visit.assigned_doctor && this.petService.pet_visit.assigned_doctor === '') {
        Swal.fire({
            title: 'Please assign attending doctor before requesting items.',
            didOpen: () => {
            },
        })
        return;
    }
    switch (this.txtchar) {
        case 'O':
            // OnlineOrder
            break;
        case 'C':
        case 'D':
        case 'E':
        case 'F':
        case 'P':
        case 'R':
        case 'S':
        case 'T':
        case 'W':
        case 'Q':
            //RequestProc
            // Swal.fire({
            //     title: 'Loading...',
            //     timerProgressBar: true,
            //     didOpen: () => {
            //         Swal.showLoading()
            //     },
            // })

            this.procedureService.strCodeName = this.filterText;
            this.procedureService.txtchar = this.txtchar;
            this.procedureService.lngPetNo = this.petService.pet.pet_no;

            $('#modalAddProc').modal('hide')

            let code = this.catalogService.codes_file.find(t => t.code_name === this.filterText);
            if (code && code.code_type < 0) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${this.filterText}`,
                    didOpen: () => {
                    },
                })
                return;
            }

            let intCodeType = code.code_type;

            if (intCodeType === undefined) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${this.filterText}`,
                    didOpen: () => {
                    },
                })
                return;
            }

            this.procedureService.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, 1, '', 0);
            await this.procedureService.checkPetSexSpecie()
                .then(() => {
                });

            if (this.procedureService.check_pss.check === 1) {
            } else {
                Swal.fire({
                    title: this.procedureService.check_pss.message,
                    didOpen: () => {
                    },
                })
                return;
            }

            this.procedureService.selectedGenericVar(true);
            $('#modalAddProcedure').modal('show')

            // var intIdx = await this.requestProc(this.procedureService.displayTran(this.petService.pet_procs), -1, this.petService.pet_procs.length, this.filterText,
            //     this.txtchar, 'ref', 1, this.petService.pet.client_no, this.petService.pet.pet_no, 0);
            // console.log(intIdx);
            // if (intIdx.RequestProc > 0)
            //     this.petService.getProcsByPetId(this.petService.current_pet_no)
            //         .then(() => {
            //             this.filteredTable = this.petService.pet_procs;
            //             Swal.fire({
            //                 title: 'Information stored correctly',
            //             })
            //         });
            return;
        default:
            break;
    }

    $('#modalProcRefer').modal('hide')
  }


  //#endregion

  //#region Est Groups
  getEstGroupsList() {
    this.estimateService.getEstGroupsList(this.petService.pet.pet_no).then(() => {
      console.log(this.estimateService.est_groups_list);
    });
  }
  //#endregion

}
